import {memo} from "react";
import {Modal} from "antd";
import PropTypes from "prop-types";

/** The customer's actual ticket numbers, in the same gold "ticket" language. */
const TicketsModal = ({open, lotteries, onClose}) => (
    <Modal
        title="Урамшууллын эрхүүд"
        open={open}
        okButtonProps={{style: {display: "none"}}}
        cancelText="Хаах"
        onCancel={onClose}
        width={420}
    >
        <div
            style={{scrollbarGutter: 'stable'}}
            className="py-4 grid grid-cols-2 gap-2 max-h-[420px] overflow-y-auto"
        >
            {lotteries?.map((lottery, index) => (
                <div key={index} className="hp-ticket-pill">{lottery}</div>
            ))}
        </div>
    </Modal>
);

TicketsModal.propTypes = {
    open: PropTypes.bool.isRequired,
    lotteries: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func.isRequired,
};

export default memo(TicketsModal);
